import { Routes } from '@angular/router';
import { HomeComponent } from './components/home.component';
import { HomeV2Component } from './components/home-v2.component';
import { ObrigadoComponent } from './components/obrigado.component';
import { HomeV3Component } from './components/home-v3.component';
import { BlogPageComponent } from './components/blog-page.component';
import { BlogArticleComponent } from './components/blog-article.component';
import { ParceirosComponent } from './components/parceiros.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'v2', component: HomeV2Component },
  { path: 'obrigado', component: ObrigadoComponent },
  { path: 'v2/obrigado', component: ObrigadoComponent },
  { path: 'v3', component: HomeV3Component },
  { path: 'blog', component: BlogPageComponent },
  { path: 'blog/:slug', component: BlogArticleComponent },
  { path: 'parceiros', component: ParceirosComponent },
];
